const yourRequestsPage = {
  loading: "Hleð inn beiðnunum þínum…",
  header: {
    title: "Beiðnirnar þínar",
    subtitle: "Aðgangs- og gagnabeiðnir sem þú hefur sent inn, úr öllum verkefnum",
    newRequest: "Ný beiðni",
  },
  errors: {
    loadFailed: "Ekki tókst að sækja beiðnirnar þínar",
    downloadFailed: "Ekki tókst að sækja gagnaskrána.",
  },
  empty: {
    noRequests: "Þú hefur ekki sent inn neinar beiðnir ennþá.",
    noMatches: "Engar beiðnir passa við þessar síur.",
  },
  filters: {
    requesterMine: "Mínar beiðnir",
    requesterAll: "Beiðnir verkefnanna minna",
    allProjects: "Öll verkefni",
    allStatuses: "Allar stöður",
    allTypes: "Allar tegundir",
    typeAccess: "Beiðni um aðgang að gagnasafni",
    typeData: "Gagnabeiðni",
    sortNewest: "Nýjast fyrst",
    sortOldest: "Elst fyrst",
    sortReviewed: "Síðast yfirfarið",
    sortStatus: "Forgangsröðun eftir stöðu",
  },
  list: {
    dataRequestPill: "Gagnabeiðni",
    accessRequestPill: "Beiðni um aðgang að gagnasafni",
  },
  detail: {
    dataRequestBadge: "Gagnabeiðni",
    accessRequestBadge: "Beiðni um aðgang að gagnasafni",
    titleLabelData: "Heiti gagnasafns",
    titleLabelAccess: "Beiðni",
    submitted: "Send inn",
    reviewed: "Yfirfarið",
    awaitingReview: "Bíður yfirferðar",
    filesLabel: "Skrár",
    filesEmpty:
      "Ekki hlaðið upp ennþá — skrár birtast hér um leið og verkefnisstjóri eða gagnaveitandi hleður þeim upp.",
    requestedFiles: "Umbeðnar skrár (1)",
    downloadData: "Sækja gögn",
    downloading: "Sæki…",
  },
};

export default yourRequestsPage;
